module.exports = __webpack_public_path__ + "img/form-settings-lock.416dc856.svg";